import SearchLocationsContainer from './locations/SearchLocationsContainer'
import './admin.scss'

  const admin = angular.module('clientDashboardApp.admin', [
    'clientDashboardApp.admin.accounts',
    'clientDashboardApp.admin.brand',
    'clientDashboardApp.admin.competitors',
    'clientDashboardApp.admin.locations',
    'clientDashboardApp.admin.locations.locationEditor',
    'clientDashboardApp.admin.groups.locations.groupLocationsEditor',
    'clientDashboardApp.admin.groups',
    'clientDashboardApp.admin.users',
    'clientDashboardApp.admin.users.editor',
    'clientDashboardApp.admin.users.locations.userLocationsEditor',
    'clientDashboardApp.admin.users.groups.userGroupsEditor',
    'clientDashboardApp.admin.adminSearch',
    'clientDashboardApp.admin.adminSearch.adminSearchService',
    'clientDashboardApp.admin.updates',
    'clientDashboardApp.admin.updates.updateService',
    'clientDashboardApp.admin.updates.updateConfirmation',
    'clientDashboardApp.admin.adminPageInfo',
    'clientDashboardApp.admin.forms',
    'clientDashboardApp.admin.forms.phone',
    'clientDashboardApp.admin.forms.phoneValidation',
    'clientDashboardApp.admin.userRoles',
    'clientDashboardApp.admin.userRoles.userRoleService',
    'clientDashboardApp.admin.users.accounts.userAccountsEditor'
  ]);


  admin.value('SearchLocationsContainer',SearchLocationsContainer);


  admin.config(function config($stateProvider, adminPageInfoProvider, $urlRouterProvider) {
      var accountIdResolve = ['accountsService', function (accountsService) {
        return accountsService.getSelectedAccountOrElseOnlyAccountOrAll()
      }];

      $urlRouterProvider
        .when('/admin/v2', '/admin/v2/users')
        .when('/admin/v2/locations/:locationId/competitor/create', '/admin/v2/locations/:locationId/competitors/create')


      $stateProvider
        .state('admin_v2', {
          url: '/admin/v2',
          abstract: true,
          template: "<ui-view/>",
          resolve: {
            security: ['$q','userService', function($q,userService) {
              return userService.currentUser().then(user => {
                if (_.contains(user.permissions,'ReadOnly')) {
                  return $q.reject("Not Authorized");
                }
              })
            }]
          }
        })
        .state('admin_v2.user', {
          url: '/user',
          template: require('./myAccount.html'),
          controller: 'MyAccountCtrl'
        })
        .state('admin_v2.accounts', {
          url: '/accounts',
          template: require('./accounts/accountsManager.html'),
          controller: 'AccountManagerCtrl',
          controllerAs: 'vm',
          resolve: {
            pageInfo: function () {
              return adminPageInfoProvider.setIfFirstTimeAppLoad({type:'account',mode:'manage'})
            },
            accountId: accountIdResolve
          },
          ncyBreadcrumb: {
            label: 'Manage Accounts'
          }
        })
        .state('admin_v2.account_create', {
          url: '/accounts/create',
          template: require('./accounts/editor/accountsEditor.html'),
          controller: 'AccountCreatorCtrl',
          controllerAs: 'vm',
          resolve: {
            pageInfo: function () {
              return adminPageInfoProvider.setIfFirstTimeAppLoad({type:'account',mode:'create'})
            },
            accountId: accountIdResolve
          },
          ncyBreadcrumb: {
            label: 'Create',
            parent: 'admin_v2.accounts'
          }
        })
        .state('admin_v2.account_edit', {
          url: '/accounts/:accountId/edit',
          template: require('./accounts/editor/accountsEditor.html'),
          controller: 'AccountCreatorCtrl',
          controllerAs: 'vm',
          resolve: {
            pageInfo: function () {
              return adminPageInfoProvider.setIfFirstTimeAppLoad({type:'account',mode:'edit'})
            },
            accountId: accountIdResolve
          },
          ncyBreadcrumb: {
            label: 'Edit',
            parent: 'admin_v2.accounts'
          }
        })
        .state('admin_v2.locations', {
          url: '/locations?showUpload',
          template: require('./locations/locationsManager.html'),
          controller: 'LocationsManagerCtrl',
          controllerAs: 'vm',
          params: {
            account: 'all',
            sortField: 'businessName',
            sortOrder: 'ASC',
            pageSize: 10
          },
          resolve: {
            pageInfo: function () {
              return adminPageInfoProvider.setIfFirstTimeAppLoad({type:'location',mode:'manage'})
            },
            accountId: (accountsService) => accountsService.getSelectedAccountOrElseOnlyAccountOrNull()
          },
          ncyBreadcrumb: {
            label: 'Manage Locations'
          }
        })
        .state('admin_v2.locations_search_to_add', {
          url: '/locations/searchToAdd',
          template: `<react-component name="SearchLocationsContainer" props="props" />`,
          controller: ['$scope', 'locationService','locationsManagerService', 'accounts', 'categories', 'editorData',
            function ($scope, locationService, locationsManagerService, accounts, categories, editorData) {
              $scope.props = {
                accounts,
                categories,
                editorData,
                locationService,
                locationsManagerService,
              }
            }
          ],
          resolve: {
            editorData: ["locationMgmtService", locationMgmtService => locationMgmtService.locationEditorData()],
            accounts: ["accountsService", (accountsService) => {
              return accountsService.listAccounts().then(result => result.accounts)
            }],
            categories: ["keywordService", (keywordService) => {
              return keywordService.listKeywords("", 0, 9001, true)
                .then(x => x.keywords.map(kw => ({value: kw.text, label: kw.text})))
            }

            ]
          },
          ncyBreadcrumb: {
            label: 'Search To Add Locations'
          }
        })

        .state('admin_v2.locations_create', {
          url: '/locations/create',
          template: require('./locations/editor/locationsEditor.html'),
          controller: 'LocationsEditorCtrl',
          controllerAs: 'vm',
          resolve: {
            pageInfo: function () {
              return adminPageInfoProvider.setIfFirstTimeAppLoad({type:'location',mode:'create'})
            },
            locationId: function() { return null },
            accountId: (accountsService) => accountsService.getSelectedAccountOrElseOnlyAccountOrNull(),
            $uibModalInstance: () => null,
            type: () => 'location',
            mode: () => 'create'
          },
          ncyBreadcrumb: {
            label: 'Create',
            parent: 'admin_v2.locations'
          }
        })
        .state('admin_v2.location', {
          url: '/locations/:locationId',
          abstract: true,
          template: '<ui-view/>',
          resolve: {
            locationId: function($stateParams) { return $stateParams.locationId; }
          }
        })
        .state('admin_v2.location.edit', {
          url: '/edit',
          template: require('./locations/editor/locationsEditor.html'),
          controller: 'LocationsEditorCtrl',
          controllerAs: 'vm',
          resolve: {
            pageInfo: function () {
              return adminPageInfoProvider.setIfFirstTimeAppLoad({type:'location',mode:'edit'})
            },
            accountId: accountIdResolve,
            $uibModalInstance: () => null,
            type: () => 'location',
            mode: () => 'edit'
          },
          ncyBreadcrumb: {
            label: 'Edit',
            parent: 'admin_v2.locations'
          }
        })
        .state('admin_v2.location.competitors', {
          url: '/competitors',
          template: require('./competitors/competitorsManager.html'),
          controller: 'CompetitorsManagerCtrl',
          controllerAs: 'vm',
          resolve: {
            pageInfo: function () {
              return adminPageInfoProvider.setIfFirstTimeAppLoad({type:'competitor',mode:'manage'})
            }
          },
          ncyBreadcrumb: {
            label: 'Competitors',
            parent: 'admin_v2.locations'
          }
        })
        .state('admin_v2.location.competitors_create', {
          url: '/competitors/create',
          template: require('./locations/editor/locationsEditor.html'),
          controller: 'LocationsEditorCtrl',
          controllerAs: 'vm',
          resolve: {
            pageInfo: function () {
              return adminPageInfoProvider.setIfFirstTimeAppLoad({type:'competitor',mode:'create'})
            },
            accountId: () => null,
            $uibModalInstance: () => null,
            type: () => 'competitor',
            mode: () => 'create'
          },
          ncyBreadcrumb: {
            label: 'Create',
            parent: 'admin_v2.location.competitors'
          }
        })
        .state('admin_v2.location.competitors_edit', {
          url: '/competitors/:competitorId/edit',
          template: require('./locations/editor/locationsEditor.html'),
          controller: 'LocationsEditorCtrl',
          controllerAs: 'vm',
          resolve: {
            pageInfo: function () {
              return adminPageInfoProvider.setIfFirstTimeAppLoad({type:'competitor',mode:'edit'})
            },
            accountId: () => null,
            $uibModalInstance: () => null,
            type: () => 'competitor',
            mode: () => 'edit'
          },
          ncyBreadcrumb: {
            label: 'Edit',
            parent: 'admin_v2.location.competitors'
          }
        })
        .state('admin_v2.groups', {
          url: '/groups',
          template: require('./groups/groupsManager.html'),
          controller: 'GroupsManagerCtrl',
          controllerAs: 'vm',
          resolve: {
            pageInfo: function () {
              return adminPageInfoProvider.setIfFirstTimeAppLoad({type:'group',mode:'manage'})
            },
            accountId: accountIdResolve
          },
          ncyBreadcrumb: {
            label: 'Manage Groups'
          }
        })
        .state('admin_v2.groups_create', {
          url: '/groups/create',
          template: require('./groups/edit/groupEditor.html'),
          controller: 'GroupEditorCtrl',
          controllerAs: 'vm',
          resolve: {
            pageInfo: function () {
              return adminPageInfoProvider.setIfFirstTimeAppLoad({type:'group',mode:'create'})
            },
            accountId: accountIdResolve
          },
          ncyBreadcrumb: {
            label: 'Create',
            parent: 'admin_v2.groups'
          }
        })
        .state('admin_v2.groups_edit', {
          url: '/groups/:groupId/edit',
          template: require('./groups/edit/groupEditor.html'),
          controller: 'GroupEditorCtrl',
          controllerAs: 'vm',
          resolve: {
            pageInfo: function () {
              return adminPageInfoProvider.setIfFirstTimeAppLoad({type:'group',mode:'edit'})
            },
            accountId: accountIdResolve
          },
          ncyBreadcrumb: {
            label: 'Edit',
            parent: 'admin_v2.groups'
          }
        })
        .state('admin_v2.groups_locations', {
          url: '/groups/:groupId/locations',
          template: require('./groups/locations/groupLocationsEditor.html'),
          controller: 'GroupLocationsEditorCtrl',
          controllerAs: 'vm',
          resolve: {
            pageInfo: function () {
              return adminPageInfoProvider.setIfFirstTimeAppLoad({type:'groupLocation',mode:'edit'})
            },
            accountId: accountIdResolve
          },
          ncyBreadcrumb: {
            label: 'Edit Locations for {{vm.groupName}}',
            parent: 'admin_v2.groups'
          }
        })
        .state('admin_v2.manage_scoring', {
          url: '/manageScoring',
          template: require('../scores/manageScore/manageScore.html'),
          controller: 'ManageScoreCtrl',
          resolve: {
            pageInfo: () => {
              //TODO - most likely is not right for now
              return adminPageInfoProvider.setIfFirstTimeAppLoad({type:'account', mode:'manage'})
            },
            accountId: accountIdResolve
          },
          ncyBreadcrumb: {
            label: 'Manage Scoring'
          }
        })
        .state('admin_v2.users', {
          url: '/users',
          template: require('./users/usersManager.html'),
          controller: 'UserManagerCtrl',
          controllerAs: 'vm',
          resolve: {
            pageInfo: function () {
              return adminPageInfoProvider.setIfFirstTimeAppLoad({type:'user',mode:'manage'})
            },
            accountId: accountIdResolve
          },
          ncyBreadcrumb: {
            label: 'Users'
          }
        })
        .state('admin_v2.users_create', {
          url: '/users/create?accountId',
          template: require('./users/editor/userEditor.html'),
          controller: 'UserEditorCtrl',
          controllerAs: 'vm',
          resolve: {
            pageInfo: function () {
              return adminPageInfoProvider.setIfFirstTimeAppLoad({type:'user',mode:'create'})
            },
            accountId: function($stateParams, accountsService) {
              return $stateParams.accountId ?
                $stateParams.accountId :
                accountsService.getSelectedAccountOrElseOnlyAccountOrNull();
            },
            forceUserId: () => null,
            homeState: () => 'admin_v2.users'
          },
          ncyBreadcrumb: {
            label: 'Create',
            parent: 'admin_v2.users'
          }
        })
        .state('admin_v2.users_edit', {
          url: '/users/:userId/edit',
          template: require('./users/editor/userEditor.html'),
          controller: 'UserEditorCtrl',
          controllerAs: 'vm',
          resolve: {
            pageInfo: function () {
              return adminPageInfoProvider.setIfFirstTimeAppLoad({type:'user',mode:'edit'})
            },
            accountId: accountIdResolve,
            forceUserId: () => null,
            homeState: () => 'admin_v2.users'
          },
          ncyBreadcrumb: {
            label: 'Edit',
            parent: 'admin_v2.users'
          }
        })
        .state('admin_v2.updateProfile', {
          url: '/user/updateProfile',
          template: require('./users/editor/userEditor.html'),
          controller: 'UserEditorCtrl',
          controllerAs: 'vm',
          resolve: {
            pageInfo: function () {
              return adminPageInfoProvider.setIfFirstTimeAppLoad({type:'user',mode:'edit'})
            },
            accountId: accountIdResolve,
            forceUserId: function(userService) {
              return userService.currentUser().then(function(user) {
                return user.userId
              });
            },
            homeState: function() {
              return 'user.account';
            }
          },
          ncyBreadcrumb: {
            label: 'Update Profile'
          }
        })
        .state('admin_v2.users_locations', {
          url: '/users/:userId/locations',
          template: require('./users/locations/userLocationsEditor.html'),
          controller: 'UserLocationsEditorCtrl',
          controllerAs: 'vm',
          resolve: {
            pageInfo: function () {
              return adminPageInfoProvider.setIfFirstTimeAppLoad({type:'userLocation',mode:'edit'})
            },
            accountId: accountIdResolve
          },
          ncyBreadcrumb: {
            label: 'Edit Locations for {{vm.username}}',
            parent: 'admin_v2.users'
          }
        })
        .state('admin_v2.users_groups', {
          url: '/users/:userId/groups',
          template: require('./users/groups/userGroupsEditor.html'),
          controller: 'UserGroupsEditorCtrl',
          controllerAs: 'vm',
          resolve: {
            pageInfo: function () {
              return adminPageInfoProvider.setIfFirstTimeAppLoad({type:'userGroup',mode:'edit'})
            },
            accountId: accountIdResolve
          },
          ncyBreadcrumb: {
            label: 'Edit Groups for {{vm.username}}',
            parent: 'admin_v2.users'
          }
        })
        .state('admin_v2.users_accounts', {
          url: '/users/:userId/accounts',
          template: require('./users/accounts/userAccountsEditor.html'),
          controller: 'UserAccountsEditorCtrl',
          controllerAs: 'vm',
          ncyBreadcrumb: {
            label: 'Edit Accounts for {{vm.user.username}}',
            parent: 'admin_v2.users'
          },
          resolve: {
            allAccounts: ["accountsService", (accountsService) => {
              return accountsService.listAccounts().then(result => result.accounts);
            }],
            accounts: ["accountsService", "allAccounts", "$stateParams", (accountsService, allAccounts, $stateParams) => {
              return accountsService.accountsForUser($stateParams.userId).then(selectedAccounts => {
                return allAccounts.map(account => {
                  if (selectedAccounts.accountIds.indexOf(account.id) !== -1) {
                    account.selected = true
                  }
                  return account;
                })
              })
            }],
            user: ["userManagerService", "$stateParams", (userManagerService, $stateParams) => {
              return userManagerService.getUser($stateParams.userId).then(response => {
                return response.data
              });
            }]
          }
        })
        .state('admin_v2.user_roles', {
          url: '/userRoles',
          template: require('./userRoles/userRoles.html'),
          controller: 'UserRoleManagerCtrl',
          controllerAs: 'vm',
          resolve: {
            pageInfo: function () {
              return adminPageInfoProvider.setIfFirstTimeAppLoad({type:'userRole',mode:'manage'})
            }
          },
          ncyBreadcrumb: {
            label: 'Manage User Roles'
          }
        })
        .state('admin_v2.brand', {
          url: '/brand',
          template: require('./brand/brandManager.html'),
          controller: 'BrandManagerCtrl',
          resolve: {
            pageInfo: function () {
              return adminPageInfoProvider.setIfFirstTimeAppLoad({type:'brand',mode:'manage'})
            }
          }
        })
        .state('admin_v2.credentials', {
          url: '/credentials?showErrors',
          template: require('./credentialManagement/credentialsList.html'),
          controller: 'CredentialsListController',
          controllerAs: 'vm'
        })
        .state('admin_v2.customProviders', {
          url: '/customProviders',
          template: require('./customProviders/customProviders.html'),
          controller: 'CustomProvidersCtrl'
        })
        .state('admin_v2.upload_tool', {
          url: '/upload',
          template: require('./uploadTool/uploadTool.html'),
          controller: 'UploadToolCtrl'
        })
        .state('admin_v2.notification_settings', {
          url: '/notificationSettings',
          template: require('./notifications/notificationSettings.html'),
          controller: 'NotificationSettingsCtrl'
        })
        .state('admin_v2.instant_audit_usage', {
          url: '/instantAuditsUsage',
          template: '<react-component name="InstantAuditsUsage"/>'
        })
        .state('admin_v2.local_pages_templates', {
          url: '/localPagesTemplates',
          template: '<react-component name="ManageTemplatesList"/>'
        })
        .state('admin_v2.manage_locations_new', {
          url: '/manageLocationsNew',
          template: '<react-component name="ManageLocationsList"/>'
        })
        .state('admin_v2.manage_locations_add_new', {
          controller: ($stateParams, $scope) => {
            $scope.locationId = $stateParams.locationId;
          },
          url: '/locations/addNew',
          template: '<react-component name="ManageLocationsList" props="{createMode: true}"/>'
        })
        .state('admin_v2.manage_locations_edit_new', {
          controller: ($stateParams, $scope) => {
            $scope.locationId = $stateParams.locationId;
          },
          url: '/locations/:locationId/editNew',
          template: '<react-component name="ManageLocationsList" props="{createMode: false, locationId: locationId}"/>'
        })
    });

  function requireAll(r) { r.keys().forEach(r); }; requireAll(require.context('./', true, /\.js$/));


